 <template>
  <div class="filterbgs">
    <!-- 悬浮按钮 -->
    <div class="handleBtnList  handleBtnListBox">
      <div class="handle_item " @click="navhelp(1)">
        <div class="handle_img">
          <img class="show" src="https://oss.ansongqiubo.com/assets/home/icon_jiaru_wu@2x.png" alt="" />
          <img
            class="hiddens"
            src="https://oss.ansongqiubo.com/assets/home/icon_jiaru_ke@2x_1.png"
            alt=""
          />
        </div>
        <div class="addBox">加入我们</div>
        <!--  v-show="erweimatanchuang"  -->
        <!--  @mouseover="erweima" @mouseleave="erweima2" -->

        <div class="show_join">
          <div class="show_join_box">
            <div class="show_join_item">
              <span class="show_json_name">主播申请入驻群</span><br />
              <span class="number">QQ群号:910966490</span><br />
              <img src="https://oss.ansongqiubo.com/Image/erweima/shenqingruzhu.png" alt="" />
            </div>
            <div class="show_join_item">
              <span class="show_json_name">投诉</span><br />
              <span class="number">QQ号:27974580</span><br />
              <img src="https://oss.ansongqiubo.com/Image/erweima/zb.png" alt="" />
            </div>
          </div>
          <div class="right_icons"></div>
        </div>
      </div>
      <!-- <div class="handle_item" @click="navhelp(2)">
        <div class="handle_img">
          <img class="show" src="https://oss.ansongqiubo.com/assets/home/icon_zhinan_wu@2x.png" alt="" />
          <img
            class="hiddens"
            src="https://oss.ansongqiubo.com/assets/home/icon_zhinan_ke@2x_1.png"
            alt=""
          />
        </div>
        <div class="addBox">新手指南</div>
      </div> -->
      <!-- <div class="handle_item" @click="navhelp(3)">
        <div class="handle_img">
          <img class="show" src="https://oss.ansongqiubo.com/assets/home/icon_yonghu_wu@2x.png" alt="" />
          <img
            class="hiddens"
            src="https://oss.ansongqiubo.com/assets/home/icon_qieyi_ke@2x.png"
            alt=""
          />
        </div>
        <div class="addBox">龙珠协议</div>
      </div> -->
      <div class="handle_item" @click="navhelp(4)">
        <div class="handle_img">
          <img class="show" src="https://oss.ansongqiubo.com/assets/home/icon_zhibo_wu@2x.png" alt="" />
          <img
            class="hiddens"
            src="https://oss.ansongqiubo.com/assets/home/icon_zhibo_ke@2x.png"
            alt=""
          />
        </div>
        <div class="addBox">我要开播</div>
      </div>
      <div class="handle_item" @click="navhelp(5)">
        <div class="handle_img">
          <img
            class="show"
            src="https://oss.ansongqiubo.com/assets/home/icon_huojian_wu@2x.png"
            alt=""
          />
          <img
            class="hiddens"
            src="https://oss.ansongqiubo.com/assets/home/icon_huojian_ke@2x_1.png"
            alt=""
          />
        </div>
        <div class="addBox">回到顶部</div>
      </div>
    </div>
    <div
      @mouseover="erweima"
      @mouseleave="erweima2"
      style="
        text-align: center;
        border-radius: 0px 5px 5px 0px;
        position: absolute;
        width: 113px;
        height: 95px;
        bottom: 280px;
        left: 0px;
        z-index: 10;
      "
    >
      <img
        style="margin-top: 3px; width: 100%; height: 100%"
        src="https://oss.ansongqiubo.com/Image/erweima/tu2x.png"
        alt=""
      />
    </div>
    <div
      v-show="erweimatanchuang"
      @mouseover="erweima"
      @mouseleave="erweima2"
      style="
        position: absolute;
        left: 95px;
        bottom: 340px;
        border-style: solid;
        border-width: 10px 10px 10px 10px;
        border-color: transparent #ffffff transparent transparent;
        width: 0px;
        height: 0px;
        z-index: 10;
      "
    ></div>
    <div
      v-show="erweimatanchuang"
      @mouseover="erweima"
      @mouseleave="erweima2"
      style="
        border-radius: 5px;
        width: 150px;
        height: 327px;
        background: #ffffff;
        position: absolute;
        bottom: 50px;
        left: 115px;
        z-index: 10;
      "
    >
      <div
        style="
          width: 100%;
          height: 50%;
          text-align: center;
          box-sizing: border-box;
          padding-top: 15px;
        "
      >
        <span style="font-size: 16px; color: #721edc">主播申请入驻群</span><br />
        <span style="font-size: 12px">QQ群号:910966490</span><br />
        <img
          style="width: 78px; height: 78px; margin-top: 3px"
          src="https://oss.ansongqiubo.com/Image/erweima/fs.png"
          alt=""
        />
      </div>
      <div
        style="
          width: 100%;
          height: 50%;
          text-align: center;
          box-sizing: border-box;
          padding-top: 15px;
        "
      >
        <span style="font-size: 16px; color: #721edc">投诉</span><br />
        <span style="font-size: 12px">QQ号:27974580</span><br />
        <img
          style="width: 78px; height: 78px; margin-top: 3px"
          src="https://oss.ansongqiubo.com/Image/erweima/zb.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      erweimatanchuang: false,
    };
  },
  methods: {
    // 悬浮功能
    navhelp(e) {
      console.log("e :>> ", e);
      if (e == 5) {
        this.backtop();
      }
      if (e == 4) {
        if (!localStorage.getItem("token")) {
            this.$emit('login')
            return;
        }

        this.pageRouter({
          path: 'pageFull', // 'download',
          query: {
            rid: 9
          }
        })


        // this.$store.dispatch('getUserInfoData',1).then((result) => {
        //   console.log('获取用户信息1', result);
        //   if(result &&  result.userInfo && result.userInfo.identity == 2 ){
        //    this.pageRouter({
        //      path: '/tianjiazhiboyuan',
        //      query: {id:8,tab:2,}
        //    })
        //   }else{
        //     this.pageRouter({
        //       path: '/anchor',
        //     })
        //   }
        // });
      }
    },
    pageRouter(query) {
      this.$store.commit('pageRouter', {
        type: 1,
        query,
      })
    },
    backtop() {
      /**
       * 回到顶部功能实现过程：
       * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
       * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
       * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
       * 4. 最后记得在移动到顶部时，清除定时器
       */
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
    erweima() {
      this.erweimatanchuang = true;
    },
    erweima2() {
      this.erweimatanchuang = false;
    },
  },
};
</script>

<style lang='scss'>
  .handleBtnListBox{
    background: #ffffff;
  }
.handleBtnList {
  position: fixed;
  right: 0;
  top: 46vh;
  width: 72px;
  // height: 334px;
  box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.1);
  border-radius: 6px 0px 0px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;

  .show_join {
    border-radius: 5px;
    display: none;
    position: absolute;
    opacity: 0;
    top: -20px;
    left: -160px;
    z-index: 100;
    .right_icons {
      border-style: solid;
      // transform: rotate(90deg);
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 10px solid #fff;
      border-bottom: 10px solid transparent;
      width: 0px;

      height: 0px;
      z-index: 10;
    }
    .show_join_box {
      width: 150px;
      background: #ffffff;

      height: 327px;
      display: flex;
      flex-direction: column;
    }
    .show_join_item {
      width: 100%;
      height: 50%;
      text-align: center;
      box-sizing: border-box;
      padding-top: 15px;
      .show_join_name {
        font-size: 16px;
        color: #721edc;
      }
      .number {
        font-size: 12px;
      }
      img {
        width: 96px;
        height: 96px;
        margin-top: 3px;
      }
    }
    .show_join_item:last-child {
      padding-top: 0 !important;
    }
  }
  .handle_item {
    cursor: pointer;
    width: 72px;
    border-radius: 10px;
    display: flex;
    margin-bottom: 16px;
    flex-direction: column;
    align-items: center;
    position: relative;
    .addBox {
      margin-top: 6px;
      width: 48px;
      height: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 12px;
    }
    .handle_img {
      display: flex;
      justify-content: center;
      .hiddens {
        display: none;
      }
    }
    img {
      width: 28px;
      height: 28px;
    }
  }
  .handle_item:last-child {
    margin-bottom: 0 !important;
  }
  .handle_item:hover {
    .show {
      display: none;
    }
    .addBox {
      color: #721edc;
    }
    .hiddens {
      display: block;
    }
    .show_join {
      display: flex;

      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/component/JoinQrcode.vue